import { getMethod, postMethod } from '@/services/apis/http-server';
import fetchClient from '@/services/apis/common';
export const getListPlans = async () => {
  try {
    const response = await getMethod(`client/plans`);
    return response;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const register = async (body: Record<string, any>) => {
  try {
    const response = await fetchClient.postMethod(
      `client/plans/register`,
      body,
    );
    return response;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getNewPlan = async () => {
  try {
    const response = await fetchClient.getMethod('client/plans/get-new-plan');
    return response;
  } catch (error) {
    console.error('Error fetching profile: ', error);
  }
};

export const getOrderCode = async (id: string) => {
  try {
    const response = await fetchClient.getMethod(
      `client/plans/order-code/${id}`,
    );
    return response;
  } catch (error) {
    console.error('Error fetching profile: ', error);
  }
};

export const checkDownloadStatus = async (body: any) => {
  try {
    const response = await fetchClient.getMethod(
      'client/plans/download-status',
      body,
    );
    return response;
  } catch (error) {
    console.error('Error fetching profile: ', error);
  }
};

export const checkVoucher = async (body: any) => {
  try {
    const response = await fetchClient.postMethod(
      'client/discount-check',
      body,
    );
    return response;
  } catch (error) {
    console.error('Error fetching voucher: ', error);
  }
};
